import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/icons//back.svg';
import {
  Button,
  DateRangeSelector,
  ENUM_DATE_RANGE,
  HorizontalList,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { ReactComponent as ExportIcon } from 'assets/icons/export.svg';
import { StatusFilterType } from './types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CoKitchenType } from 'models/cokitchen.model';
import { OrderType } from 'models/order.model';
import { LOGISTICS_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { apiService } from 'utils/api';
import OrderHistoryCards from 'components/logistics/order-history/order-history-cards';
import ExportOrdersModal from 'components/logistics/export-orders';

const FILTER_LIST: { name: string; value: StatusFilterType }[] = [
  {
    name: 'All',
    value: 'ALL'
  },
  {
    name: 'Completed trips',
    value: 'COMPLETED'
  },
  {
    name: 'Failed trips',
    value: 'CANCELLED'
  },
  {
    name: 'Recalled trips',
    value: 'RECALLED'
  }
];

const OrderHistory = () => {
  const didMount = useRef(false);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);

  const [count, setCount] = useState(1);
  const [total, setTotal] = useState(0);

  const [showExportModal, setShowExportModal] = useState(false);
  const [filters, setFilters] = useState({
    activeKitchen: {} as CoKitchenType,
    date: getDateRangeSelector(ENUM_DATE_RANGE.YESTERDAY)
  });
  const [orders, setOrders] = useState<OrderType[]>([]);
  const [statusFilter, setStatusFilter] = useState<StatusFilterType>('ALL');

  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  useEffect(() => {
    setHasMore(orders?.length < total);
  }, [orders]);

  useEffect(() => {
    setLoading(false);
  }, []);

  const getOrderHistory = async () => {
    if (count === 1) setLoading(true);
    const { startDate: start_time, endDate: end_time } = filters.date;
    const params: any = {
      start_time,
      end_time,
      page_no: count,
      status: statusFilter === 'ALL' ? undefined : statusFilter.toLowerCase(),
      cokitchen_id: cokitchenId
    };
    // if (statusFilter === 'COMPLETED' || statusFilter === 'FAILED') {
    //   payload.status = statusFilter === 'COMPLETED';
    // }
    const res = await apiService.get('orders/history', {
      params,
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    const newOrders = count === 1 ? res.data.data.results : [...orders, ...res.data.data.results];
    setOrders(newOrders);
    setTotal(res.data.data.total);
    setLoading(false);
  };
  useEffect(() => {
    if (count === 1 && didMount.current) {
      getOrderHistory();
      return;
    }
    setCount(1);
    didMount.current = true;
  }, [statusFilter, filters.date, filters.activeKitchen]);

  useEffect(() => {
    getOrderHistory();
  }, [count]);

  return (
    <div>
      <div key={cokitchenId}>
        <Link
          replace
          to={LOGISTICS_ROUTE_KEYS.OVERVIEW}
          className='inline-flex justify-start gap-1 items-center text-[#595959] font-xs mb-[14px] cursor-pointer'>
          <BackIcon /> Back to overview
        </Link>
        <div className='flex flex-wrap items-center justify-between mb-6 gap-4'>
          <h1 className='font-semibold text-2xl'>Order History</h1>
          <div className='max-w-[170px]'>
            <Button small variant='block' color='primary' onClick={() => setShowExportModal(true)}>
              <ExportIcon className='mr-1' />
              Export
            </Button>
          </div>
        </div>
        <div className='flex flex-col md:flex-row md:items-center justify-between mb-2 gap-4'>
          <div className='flex items-center'>
            <label htmlFor='' className='mr-3'>
              Overview period:
            </label>
            <DateRangeSelector
              defaultRange={ENUM_DATE_RANGE.YESTERDAY}
              onChange={({ date }) => setFilters({ ...filters, date })}
              showTime
            />
          </div>
        </div>
        <HorizontalList
          list={FILTER_LIST}
          value={statusFilter}
          onChange={(item) => setStatusFilter(item.value)}
        />
        <hr className='border-gray-border mb-8' />

        {loading ? (
          <h2 className='font-bold text-center md:h-[200px] flex items-center justify-center mx-auto text-lg md:text-2xl'>
            Loading...
          </h2>
        ) : orders?.length === 0 ? (
          <h2 className='font-bold text-center md:h-[200px] flex items-center mx-auto text-lg md:text-2xl'>
            There is no order history to show
          </h2>
        ) : (
          <InfiniteScroll
            hasMore={hasMore}
            next={() => {
              setCount((prev) => prev + 1);
            }}
            dataLength={orders?.length || 0}
            loader={<p className='text-center mt-8'>Loading more orders...</p>}
            endMessage={<p className='text-center mt-8'>End of list</p>}>
            <OrderHistoryCards orders={orders} />
          </InfiniteScroll>
        )}
      </div>
      <ExportOrdersModal show={showExportModal} onClose={() => setShowExportModal(false)} />
    </div>
  );
};

export default OrderHistory;
